import { Component, OnInit, ViewChild } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { AuthService } from '../../services/auth.service'
import {
  countries_en,
  countries_es,
  countries_pt,
  countries_pt_fixed
} from '../../store/countries/country-data-store'
import {
  addressTypes_es,
  addressTypes_pt,
  addressTypes_en
} from '../../store/address-types/address-type-data-store'
import { LangService } from '../../services/lang.service'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { ValidatorsService } from '../../services/validators/validators.service'
import { environment } from '../../../environments/environment'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { AppLockSessionComponent } from '../../shared/app-lock-session/app-lock-session.component'
import Swal from 'sweetalert2'
import { TranslateService } from '@ngx-translate/core'
import { ApiService } from '../../services/api.service'
import { loaderConfig } from '../../config/loader'
import { NgxUiLoaderService } from 'ngx-ui-loader'
import { Location } from '@angular/common'

@Component({
  selector: 'app-identification',
  templateUrl: './identification.component.html',
  styleUrls: ['./identification.component.css']
})
export class IdentificationComponent implements OnInit {
  /**
   * Session hash
   */
  private hash: string

  /**
   * Param hash
   */
  private param_hash: string

  /**
   * checksesInterval
   */
  private checksesInterval: any

  /**
   * modal that lock a session
   */
  @ViewChild('lockSession') private lockSession: AppLockSessionComponent

  /**
   * Indicate role of logged user (0: Gestor Flota, 1: Conductor)
   */
  public rolAcceso: number

  /**
   * Indicate role who has permission to opperate fine (0: Gestor Flota, 1: Conductor)
   */
  public rolPermiso: number

  /**
   * Indicate state of enlace (1: enviado, 2: pagado, 3: identificado, 4: compartido)
   */
  public acceso: number

  /**
   * Fine data
   */
  public finedata: any

  success = false
  portugalNacionality = false
  public countries_en: any = countries_en
  public countries_es: any = countries_es
  public countries_pt: any = countries_pt
  public addressTypes_es: any = addressTypes_es
  public addressTypes_pt: any = addressTypes_pt
  public addressTypes_en: any = addressTypes_en
  public currentLang: string
  public submitted = false
  error = false
  loading = false
  showView = false
  public loaderOptions: any = loaderConfig
  public timeOut = false
  public diffDays: number
  public diffHrs: number
  public diffMins: number
  public files = []

  registerForm: FormGroup = this.formBuilder.group(
    {
      name: ['', [Validators.required]],
      surname1: ['', [Validators.required, Validators.minLength(3)]],
      surname2: [''],
      email: [
        '',
        [Validators.required, Validators.pattern(this.vs.emailPattern)]
      ],
      phone: [
        '',
        [
          Validators.minLength(9),
          Validators.maxLength(15),
          Validators.pattern(this.vs.phonePattern)
        ]
      ],
      documentType: ['', Validators.required],
      documentNumber: ['', [Validators.required]],
      addressType: ['', Validators.required],
      addressName: ['', [Validators.required, Validators.minLength(3)]],
      addressNumber: ['', Validators.required],
      addressFloor: ['', [Validators.maxLength(2)]],
      addressDoor: [''],
      addressPostalCode: [
        '',
        [Validators.required, Validators.pattern(this.vs.postalCodePattern)]
      ],
      city: ['', Validators.required],
      region: [''],
      country: ['', Validators.required],
      checkLegal: [false, Validators.requiredTrue]
    },
    {
      validators: [this.vs.validateDNI('documentType', 'documentNumber')]
    }
  )
  public displaySubmit = true

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService,
    private translate: TranslateService,
    private lang: LangService,
    private formBuilder: FormBuilder,
    private vs: ValidatorsService,
    private http: HttpClient,
    private apiService: ApiService,
    private ngxLoader: NgxUiLoaderService,
    private location: Location
  ) {
    this.hash = this.authService.getHash()

    this.route.params.subscribe((params) => {
      this.param_hash = params['hash']
    })
    this.checkPortugalNacionality()
  }

  ngOnInit() {
    localStorage.setItem('check_license', '0')
    this.ngxLoader.start()
    this.files = JSON.parse(localStorage.getItem('expedientes'))
    this.currentLang = this.lang.getLang()
    // if session hash is different from hash of route eject from session to login page.
    if (this.hash !== this.param_hash) {
      this.lockSession.open()
      return false
    }

    this.checksesInterval = setInterval(() => {
      this.hash = this.authService.getHash()
      if (this.hash !== this.param_hash) {
        this.lockSession.open()
        clearInterval(this.checksesInterval)
        return false
      }
    }, 1000 * 60)

    this.apiService
      .getFineData(`${this.hash}`, `${this.files[0]}`)
      .subscribe((response: any) => {
        this.finedata = response
        this.acceso = this.finedata.acceso
        this.rolAcceso = this.finedata.rolAcceso
        this.rolPermiso = this.finedata.rolPermiso
        const fechaHoraServidor = this.finedata.fechaHoraServidor.date
        const fechaFinEnlace = this.finedata.fechaFinEnlace.date
        const dateExpires = new Date(fechaFinEnlace.replace(' ', 'T'))
        const nowdate = new Date(fechaHoraServidor.replace(' ', 'T'))
        if (nowdate.getTime() > dateExpires.getTime()) {
          this.timeOut = true
        } else {
          const diffMs = Math.abs(dateExpires.getTime() - nowdate.getTime())
          this.diffDays = Math.floor(diffMs / 86400000)
          this.diffHrs = Math.floor((diffMs % 86400000) / 3600000)
          this.diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000)
        }
        this.ngxLoader.stop()
        this.ejectFromRoute()
      })
  }

  viewFine() {
    this.location.back()
  }

  checkPortugalNacionality() {
    this.portugalNacionality = !this.portugalNacionality
    if (this.portugalNacionality) {
      this.registerForm.removeControl('licenseNonPortugal')
      this.registerForm = this.formBuilder.group(
        {
          ...this.registerForm.controls,
          contribuyentNumber: ['', [Validators.required]],
          documentNumber2: ['', [Validators.required]],
          documentType2: ['', [Validators.required]]
        },
        {
          validators: [
            this.vs.validarCamposPortugal('documentType2', 'documentNumber2'),
            this.vs.validateDNI('documentType', 'documentNumber'),
            this.vs.validateContribuyentNumber('contribuyentNumber')
          ]
        }
      )
      /*
        Indicamos que el documento es tipo LICENCIA (5)
       */
      this.registerForm.get('documentType').setValue('5')
      localStorage.setItem('check_license', '0')
      this.registerForm.controls['region'].setValidators([])
      this.registerForm.get('documentNumber').reset('')
      this.countries_en = countries_pt_fixed
      this.countries_es = countries_pt_fixed
      this.countries_pt = countries_pt_fixed
    } else {
      this.registerForm = this.formBuilder.group({
        ...this.registerForm.controls,
        licenseNonPortugal: ['', [Validators.required]]
      })
      localStorage.setItem('check_license', '0')
      /** eliminamos los validaciones cuando no es portugal **/
      this.registerForm.clearValidators()
      /** eliminamos los campos del forumlario para cuando es portugal */
      this.registerForm.removeControl('contribuyentNumber')
      this.registerForm.removeControl('documentNumber2')
      this.registerForm.removeControl('documentType2')
      /* reseteamos los valores de los campos de selección */

      this.registerForm.get('documentType').reset('')
      this.registerForm.get('documentNumber').reset('')
      /*
        Añadimos los campos que vamos a comparar ya que eliminamos los validators
       */
      this.registerForm.setValidators(
        this.vs.validateDNI('documentType', 'documentNumber')
      )
      this.registerForm.controls['region'].setValidators([Validators.required])
      this.countries_en = countries_en
      this.countries_es = countries_es
      this.countries_pt = countries_pt
    }
  }

  /**
   * POST Call that is used to identify given driver
   * @param {json} datos`)
   */
  identifyDriver(datos: any) {
    this.displaySubmit = false
    this.loading = true
    this.error = false
    this.success = false
    const URL_API = environment.URL_API
    const url = URL_API + 'identificar/' + this.authService.getHash()
    const headers: HttpHeaders = new HttpHeaders().set(
      'TOKEN',
      this.authService.getToken()
    )
    return this.http.post<any>(url, datos, { headers }).subscribe(
      (data) => {
        setTimeout(() => {
          this.loading = false
          Swal.fire({
            title: this.translate.instant('AppLockSession.identifing.header'),
            text: this.translate.instant('AppLockSession.identifing.body'),
            confirmButtonColor: '#585D6A',
            confirmButtonText:
              '<i class="fa fa-chevron-right"></i> ' +
              this.translate.instant('AppLockSession.identifing.button'),
            allowOutsideClick: false,
            allowEscapeKey: false,
            type: 'success'
          }).then((result) => {
            if (result.value) {
              this.viewFine()
            }
          })
        }, 10000)
      },
      (error) => {
        this.success = false
        this.error = true
        this.loading = false
        this.displaySubmit = true
      }
    )
  }

  get form() {
    return this.registerForm.controls
  }
  fieldIsValid(campo: string) {
    return (
      this.registerForm.controls[campo].errors &&
      this.registerForm.controls[campo].touched
    )
  }

  get nameErrorMsg(): string {
    const errors = this.registerForm.get('name').errors
    let msg = ''
    if (errors.required) {
      msg = this.translate.instant('IdentificationPage.Form.Errors.Empty')
      return msg
    }
    if (errors.pattern) {
      msg = this.translate.instant('IdentificationPage.Form.Errors.LettersOnly')
      return msg
    }
    return msg
  }

  get surname1ErrorMsg(): string {
    const errors = this.registerForm.get('surname1').errors
    let msg = ''
    if (errors.required) {
      msg = this.translate.instant('IdentificationPage.Form.Errors.Empty')
      return msg
    } else if (errors.pattern) {
      msg = this.translate.instant('IdentificationPage.Form.Errors.LettersOnly')
      return msg
    }
    return msg
  }

  get surname2ErrorMsg(): string {
    const errors = this.registerForm.get('surname2').errors
    let msg = ''
    if (errors.required) {
      msg = this.translate.instant('IdentificationPage.Form.Errors.Empty')
      return msg
    } else if (errors.pattern) {
      msg = this.translate.instant('IdentificationPage.Form.Errors.LettersOnly')
      return msg
    }
    return msg
  }

  get emailErrorMsg(): string {
    const errors = this.registerForm.get('email').errors
    let msg = ''
    if (errors.required) {
      msg = this.translate.instant('IdentificationPage.Form.Errors.Empty')
      return msg
    } else if (errors.pattern) {
      msg = this.translate.instant('IdentificationPage.Form.Errors.Format')
      return msg
    }
    return msg
  }

  get phoneErrorMsg(): string {
    const errors = this.registerForm.get('phone').errors
    let msg = ''
    if (errors.required) {
      msg = this.translate.instant('IdentificationPage.Form.Errors.Empty')
      return msg
    } else if (errors.pattern) {
      msg = this.translate.instant('IdentificationPage.Form.Errors.Phone')
      return msg
    }
    return msg
  }

  get documentTypeErrorMsg(): string {
    const errors = this.registerForm.get('documentType').errors
    let msg = ''
    if (errors.required) {
      msg = this.translate.instant(
        'IdentificationPage.Form.Errors.DocumentSelect'
      )
      return msg
    }
    return msg
  }

  get documentType2ErrorMsg(): string {
    const errors = this.registerForm.get('documentType2').errors
    let msg = ''
    if (errors.required) {
      msg = this.translate.instant(
        'IdentificationPage.Form.Errors.DocumentSelect'
      )
      return msg
    }
    return msg
  }

  get documentNumberErrorMsg(): string {
    const errors = this.registerForm.get('documentNumber').errors
    let msg = ''
    if (errors.required) {
      msg = this.translate.instant('IdentificationPage.Form.Errors.Empty')
      return msg
    } else if (errors.nifError) {
      msg = this.translate.instant(
        'IdentificationPage.Form.Errors.DocumentNumber.IncorrectLetter'
      )
      return msg
    } else if (errors.dniFormatError) {
      msg = this.translate.instant(
        'IdentificationPage.Form.Errors.DocumentNumber.IncorrectDNI'
      )
      return msg
    } else if (errors.nifFormatError) {
      msg = this.translate.instant(
        'IdentificationPage.Form.Errors.DocumentNumber.IncorrectNIF'
      )
    } else if (errors.nieError) {
      msg = this.translate.instant(
        'IdentificationPage.Form.Errors.DocumentNumber.IncorrectLetter'
      )
      return msg
    } else if (errors.nieFormatError) {
      msg = this.translate.instant(
        'IdentificationPage.Form.Errors.DocumentNumber.IncorrectNIE'
      )
    } else if (errors.cifFormatError) {
      msg = this.translate.instant(
        'IdentificationPage.Form.Errors.DocumentNumber.IncorrectCIF'
      )
    } else if (errors.licenseFormatError) {
      msg = this.translate.instant(
        'IdentificationPage.Form.Errors.DocumentNumber.IncorrectLicense'
      )
      return msg
    }
    return msg
  }

  get licenseNonPortugalErrorMsg(): string {
    const errors = this.registerForm.get('documentNumber').errors
    let msg = ''
    if (errors.required) {
      msg = this.translate.instant('IdentificationPage.Form.Errors.Empty')
      return msg
    }
    return msg
  }

  get contribuyentNumberErrorMsg(): string {
    const errors = this.registerForm.get('contribuyentNumber').errors
    let msg = ''
    if (errors.contribuyentNumberFormatError) {
      msg = this.translate.instant(
        'IdentificationPage.Form.Errors.DocumentNumber.IncorrectContribuyentNumber'
      )
      return msg
    }
    return msg
  }
  get documentNumber2ErrorMsg(): string {
    const errors = this.registerForm.get('documentNumber2').errors
    let msg = ''
    if (errors.required) {
      msg = this.translate.instant('IdentificationPage.Form.Errors.Empty')
      return msg
    } else if (errors.cardFormatError) {
      msg = this.translate.instant(
        'IdentificationPage.Form.Errors.DocumentNumber.IncorrectCitizenCard'
      )
    }
    return msg
  }
  get addressTypeErrorMsg(): string {
    const errors = this.registerForm.get('addressType').errors
    let msg = ''
    if (errors.required) {
      msg = this.translate.instant('IdentificationPage.Form.Errors.Empty')
      return msg
    }
    return msg
  }
  get addressNameErrorMsg(): string {
    const errors = this.registerForm.get('addressName').errors
    let msg = ''
    if (errors.required) {
      msg = this.translate.instant('IdentificationPage.Form.Errors.Empty')
      return msg
    } else if (errors.minLength) {
      msg = 'Debe tener un mínimo de 3 caracteres'
      return msg
    }
    return msg
  }
  get addressNumberErrorMsg(): string {
    const errors = this.registerForm.get('addressNumber').errors
    let msg = ''
    if (errors.required) {
      msg = this.translate.instant('IdentificationPage.Form.Errors.Empty')
      return msg
    }
    return msg
  }

  get addressFloorErrorMsg(): string {
    const errors = this.registerForm.get('addressFloor').errors
    let msg = ''
    if (
      errors.maxLength ||
      this.registerForm.get('addressFloor').value.length > 2
    ) {
      msg = this.translate.instant('IdentificationPage.Form.Errors.MaxLength2')
      return msg
    }
    return msg
  }

  get addressPostalCodeErrorMsg(): string {
    const errors = this.registerForm.get('addressPostalCode').errors
    let msg = ''
    if (errors.required) {
      msg = 'Debe tener un máximo de 3 caracteres'
      return msg
    }
    return msg
  }
  get cityErrorMsg(): string {
    const errors = this.registerForm.get('city').errors
    let msg = ''
    if (errors.required) {
      msg = this.translate.instant('IdentificationPage.Form.Errors.Empty')
      return msg
    }
    return msg
  }
  get regionErrorMsg(): string {
    const errors = this.registerForm.get('region').errors
    let msg = ''
    if (errors.required) {
      msg = this.translate.instant('IdentificationPage.Form.Errors.Empty')
      return msg
    }
    return msg
  }
  get countryErrorMsg(): string {
    const errors = this.registerForm.get('country').errors
    let msg = ''
    if (errors.required) {
      msg = this.translate.instant('IdentificationPage.Form.Errors.Empty')
      return msg
    }
    return msg
  }

  onSubmit() {
    this.submitted = true
    if (this.registerForm.invalid) {
      this.markFormGroupTouched(this.registerForm)
      return
    }
    this.submitted = true
    let residente_portugal = 0
    if (this.portugalNacionality) {
      residente_portugal = 1
    }
    let documentNumber2 = this.registerForm.value.documentNumber2
      ? this.registerForm.value.documentNumber2
      : ''
    let documentType2 = this.registerForm.value.documentType2
      ? this.registerForm.value.documentType2
      : ''
    if (!this.portugalNacionality) {
      documentNumber2 = this.registerForm.value.licenseNonPortugal
        ? this.registerForm.value.licenseNonPortugal
        : ''
      documentType2 = '5'
    }
    const DATAFORM = {
      tipoDoc: this.registerForm.value.documentType,
      documento: this.registerForm.value.documentNumber,
      nombre: this.registerForm.value.name,
      apellido1: this.registerForm.value.surname1,
      apellido2: this.registerForm.value.surname2,
      email: this.registerForm.value.email,
      telefono: this.registerForm.value.phone,
      tipoVia: this.registerForm.value.addressType,
      nombreVia: this.registerForm.value.addressName,
      numero: this.registerForm.value.addressNumber,
      piso: this.registerForm.value.addressFloor,
      puerta: this.registerForm.value.addressDoor,
      cpostal: this.registerForm.value.addressPostalCode,
      poblacion: this.registerForm.value.city,
      provincia: this.registerForm.value.region,
      pais: this.registerForm.value.country,
      tipoDoc2: documentType2,
      documento2: documentNumber2,
      nContribuyente: this.registerForm.value.contribuyentNumber
        ? this.registerForm.value.contribuyentNumber
        : '',
      expedientes: this.files,
      residente_portugal: residente_portugal
    }
    this.identifyDriver(DATAFORM)
  }

  private markFormGroupTouched(formGroup: FormGroup) {
    ;(<any>Object).values(formGroup.controls).forEach((control) => {
      control.markAsTouched()

      if (control.controls) {
        this.markFormGroupTouched(control)
      }
    })
  }

  documentTypeNumber(document: string) {
    const documentType = ['DNI', 'NIF', 'CIF', 'NIE', 'PASAPORTE', 'LICENCIA']
    return documentType.indexOf(document)
  }

  documentType2Number(document: string) {
    const documentType = ['CARTA DO CIDADÃO', 'BILHETE DE IDENTIDAD']
    return documentType.indexOf(document)
  }

  ejectFromRoute() {
    let allowed = false
    if (this.timeOut) {
      allowed = false
    } else {
      if (this.acceso === 1) {
        if (this.rolAcceso === this.rolPermiso) {
          allowed = true
        }
      } else {
        if (
          (this.rolAcceso === 1 || this.rolAcceso === 2) &&
          this.acceso === 4
        ) {
          allowed = true
        }
      }
    }
    if (!allowed) {
      this.viewFine()
    } else {
      this.showView = true
    }
  }
}
